<label class="switch" aria-label="Toggle button">
  <input
    type="checkbox"
    [class.disabled]="disabled"
    [disabled]="disabled"
    [(ngModel)]="value"
  />
  <span class="slider round" [class.disabled]="disabled"></span>
</label>
